import { Button, Typography } from "@suraasa/placebo-ui"
import { ArrowRight } from "iconoir-react"
import { useMatch } from "react-router-dom"
import routes from "routes"

const WelcomeToSuraasa = ({ onStart }: { onStart: () => void }) => {
  const isThroughGSG = useMatch(routes.gsgCpat)

  return (
    <div>
      <div className="mx-2 md:mx-12">
        <img
          src="https://assets.suraasa.com/logos/v2/mini.webp"
          alt="logo"
          width={80}
          height={80}
        />
        <div className="h-4.5"></div>
        <Typography variant="title1">Welcome To Suraasa</Typography>
        <div className="h-2"></div>
        <Typography variant="largeBody" className="max-w-xl text-onSurface-500">
          You’re in the right place to discover teaching resources, courses, AI
          tools, and job opportunities around the world.
          <br />
          <br />
          To tailor your experience, we’d love to learn a bit more about you.
        </Typography>
        <div className="h-6"></div>
        <Button
          onClick={onStart}
          color="black"
          size="lg"
          endAdornment={<ArrowRight className="!size-2" />}
        >
          Get Started
        </Button>

        {isThroughGSG && (
          <div className="my-1 flex max-w-xl flex-col gap-0.5">
            <Typography variant="smallBody" className="text-xs text-muted">
              By proceeding, you consent to Suraasa sharing your CPAT assessment
              results and relevant data with Global Schools Group for academic
              and career-related purposes.
            </Typography>
            <Typography variant="smallBody" className="text-xs text-muted">
              You agree that Suraasa may securely use your data to support
              employment opportunities and related initiatives.
            </Typography>
          </div>
        )}
      </div>
    </div>
  )
}

export default WelcomeToSuraasa
